import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";

export const FEED_GROUP_SIZE_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

/** Stored value is an integer 1-10, or null when the admin keeps the default. */
export const normalizeFeedGroupSize = (value) => {
  const size = Number(value);
  if (Number.isInteger(size) && size >= 1 && size <= 10) return size;
  return null;
};

/**
 * How many pagents of this song, track, or challenge are served back-to-back
 * on the voting feed. An empty selection keeps the default.
 */
const FeedGroupSizeField = ({ value, onChange, defaultLabel, hint }) => {
  const current = normalizeFeedGroupSize(value);
  return (
    <Box mt={3} width="100%">
      <Typography sx={{ fontWeight: 600, fontSize: "14px", marginBottom: "4px" }}>
        Voting feed group size
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 1 }}
      >
        {hint}
      </Typography>
      <TextField
        select
        fullWidth
        label="Group size"
        value={current == null ? "" : String(current)}
        onChange={(event) => {
          const next = event.target.value;
          onChange(next === "" ? null : Number(next));
        }}
        sx={{
          "& .MuiOutlinedInput-root": { borderRadius: "6px" },
          "& .MuiInputBase-input": { color: "black !important" },
        }}
      >
        <MenuItem value="">{defaultLabel}</MenuItem>
        {FEED_GROUP_SIZE_OPTIONS.map((size) => (
          <MenuItem key={size} value={String(size)}>
            {size}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default FeedGroupSizeField;
